
import { z } from "zod";

export const InvoicePartyValues = ["HOMEOWNER", "PARTNER"] as const;
export const InvoicePartySchema = /* @__PURE__ */ z.enum(InvoicePartyValues);
export const InvoiceParty: (typeof InvoicePartySchema)["enum"] = { "HOMEOWNER": "HOMEOWNER", "PARTNER": "PARTNER" };
export type InvoiceParty = (typeof InvoicePartyValues)[number];
export const InvoicePartyDisplayNames = { "HOMEOWNER": "Homeowner",
"PARTNER": "Partner", } satisfies Record<InvoiceParty, string>;
